import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { RichBanner } from '@grandvisionhq/content';
import { pushLoginAction, pushCheckedConsent, pushStartEyeTest, LaunchEyeExam } from '@grandvisionhq/eye-exam';

const RichBannerEyeExam = (props)=>{
    const eyeExamDataLayer = React.useMemo(()=>({
            onLogin: ()=>pushLoginAction('easee page')
            ,
            onConsent: (hasConsent)=>hasConsent && pushCheckedConsent('easee page')
            ,
            onStartEyeExam: ()=>pushStartEyeTest('easee page')
        })
    , []);
    return /*#__PURE__*/ React.createElement(RichBanner, swcHelpers.extends({}, props), /*#__PURE__*/ React.createElement(LaunchEyeExam, swcHelpers.extends({}, eyeExamDataLayer)));
};

export { RichBannerEyeExam };
//# sourceMappingURL=RichBannerEyeExam.js.map
